
import { Options, Vue } from "vue-class-component";
import { Layouts } from "@/components/Text.vue";

@Options({
  components: {
    Text,
  },
})
export default class LayoutChooser extends Vue {
  layouts = Layouts;
  click(chosenLayout: string) {
    this.$store.commit("setChosenLayout", chosenLayout);
    this.$router.push({ path: "/" });
  }
}
